<template>
  <div class="hero">
    <div class="container">
      <div class="row">
        <div class="col-md-6 text-hero">
          <h2>SECURE</h2>
          <p>
            We put security in the forefront. SESSIONS is built on top of WebRTC
            which has powerful end to end encrypted at the core. Additionally,
            we are HIPAA compliant. This means you can go full speed ahead in
            your Financial discussions, knowing that your data is locked and
            safe on our platform.
          </p>
        </div>
        <div class="col-md-6 img-hero">
          <img src="../../../assets/img/sessions/secure.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Secure.vue"
};
</script>

<style lang="scss" scoped>
.hero {
  min-height: 452px;
  background-image: url("../../../assets/img/sessions/secure-bg.svg");
  //background-color: #F7FAFD;
  .container {
    .text-hero {
      min-height: 452px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      h2 {
        font-style: normal;
        font-weight: bold;
        font-size: 32px;
        line-height: 44px;
        color: #474d52;
        margin-bottom: 5px;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
      }
      .btn {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 0.1em;
        text-transform: capitalize;
      }
    }
    .img-hero {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
      }
    }
  }
}
@media (max-width: 650px) {
  .hero {
    .text-hero {
      h1 {
        font-size: 60px !important;
        line-height: 70px !important;
      }
    }
  }
}
</style>
